import { Col, Flex, message, Row } from "antd";
import { TaskFormCard } from "./components/TaskForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import {
  fetchTaskById,
  updateTaskById,
} from "../../../lib/api/resources/tasks";
import { useNavigate, useParams } from "react-router-dom";
import { User } from "@rumble-it/common-lib/types/models/User.interface";
import { fetchUsersWithoutPagination } from "@/lib/api/resources/users";

export const TaskEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const taskQuery = useQuery({
    queryKey: ["task", id],
    queryFn: () => fetchTaskById(id),
  });

  const { data: users, isLoading: isUsersLoading } = useQuery({
    queryKey: ["Users"],
    queryFn: () => fetchUsersWithoutPagination(),
  });

  const userOptions = Array.isArray(users?.member)
    ? users?.member.map((acc: User) => ({
        label: acc.fullName,
        value: acc["@id"],
      }))
    : [];

  const updateTaskMutation = useMutation({
    mutationFn: (data: Task) => updateTaskById(id, data),
    onSuccess: () => {
      navigate(`/claims/tasks/${id}`);
      message.success("Taak succesvol bijgewerkt");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het bijwerken van de taak"),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <TaskFormCard
              loading={taskQuery.isLoading || isUsersLoading}
              initialValues={taskQuery.data}
              userOptions={userOptions}
              mutation={updateTaskMutation}
              title="Taak bijwerken"
              buttonText="Bijwerken"
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
